<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/user-workinfo/table">用户职业信息审核列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="职业信息提交详情"
                   name="职业信息提交详情">
        <layout-panel>
          <span slot="header">表单</span>
          <el-form ref="form"
                   :model="detail"
                   size="medium"
                   label-width="140px">
            <div class="re-el-form__flex">
              <div class="large">
                <el-form-item label="ID"
                              prop="id">
                  <span>{{ detail.id }}</span>
                </el-form-item>
                <el-form-item label="状态"
                              prop="status_cn">
                  <span :style="{color: setStatusCNColor()}">{{ detail.status_cn }}</span>
                </el-form-item>
                <el-form-item label="用户信息"
                              prop="userid">
                  <div class="user-info-wrapper">
                    <el-link target="_blank"
                             :href="`/users/detail/info?userid=${detail.userid}`"
                             type="primary">
                      ID: {{ detail.userid }}
                    </el-link>
                    <span class="info-divider">|</span>
                    <!-- <span class="info-text">手机号: {{ detail.cellphone }}</span>
                    <span class="info-divider">|</span> -->
                    <span class="info-text">姓名: {{ detail.realname }}</span>
                  </div>
                </el-form-item>

                <el-form-item label="行业"
                              prop="business_type"
                              v-if="allowAudit()">
                  <el-select v-model="editForm.business_type"
                             @change="onBusinessTypeChange"
                             clearable
                             class="form-input-width"
                             placeholder="请选择">
                    <el-option v-for="item in options.business_type"
                               :disabled="item.disabled"
                               :key="item.id"
                               :label="item.title"
                               :value="item.id">
                      <span style="float: left">{{ item.title }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.subTitle }}</span>
                    </el-option>
                  </el-select>
                  <div class="helper-text">提示：审核通过后，将自动为用户追加该行业的对应标签</div>
                  <div class="helper-text"
                       v-if="industryTags && industryTags.length">
                    行业对应标签：
                    <span v-for="tag in industryTags"
                          :key="tag.id"
                          class="tag-inline">
                    {{ tag.tagname }} ({{ tag.id }})
                  </span>
                  </div>
                </el-form-item>
                <el-form-item label="行业"
                              prop="business_type_json"
                              v-else
                              class="readonly-field">
                  <span>{{ getBusinessType() }}</span>
                </el-form-item>
                <el-form-item label="工种"
                              prop="work_type"
                              v-if="allowAudit()">
                  <el-select v-model="editForm.work_type"
                             class="form-input-width"
                             placeholder="请先选择行业">
                    <el-option v-for="item in filtered_work_type"
                               :disabled="item.disabled"
                               :key="item.id"
                               :label="item.title"
                               :value="item.id">
                      <span style="float: left">{{ item.title }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.desc }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="工种"
                              prop="work_type_cn"
                              v-else
                              class="readonly-field">
                  <span>{{ detail.work_type_cn }}</span>
                </el-form-item>
                <el-form-item label="主营品牌"
                              prop="main_brand"
                              v-if="needMainBrand()">
                  <el-input v-model.trim="editForm.main_brand"
                            v-if="allowAudit()"
                            class="form-input-width"
                            placeholder="请输入主营品牌"></el-input>
                  <span v-else>{{ getMainBrand() }}</span>
                </el-form-item>
                <el-form-item label="零工所在地"
                              prop="user_location"
                              class="readonly-field">
                  <span>{{ getUserLocation() }}</span>
                </el-form-item>
                <el-form-item label="公司名称"
                              prop="belongto"
                              v-if="allowAudit()">
                  <el-autocomplete
                    v-model.trim="editForm.belongto"
                    :fetch-suggestions="queryCompanyList"
                    placeholder="请输入或选择公司名称"
                    class="form-input-width"
                    clearable
                    :trigger-on-focus="false"
                    @select="handleCompanySelect">
                  </el-autocomplete>
                </el-form-item>
                <el-form-item label="公司名称"
                              prop="belongto"
                              v-else
                              class="readonly-field">
                  <span>{{ detail.belongto }}</span>
                </el-form-item>
                <el-form-item label="工作证明"
                              prop="workcard_photo">
                  <div class="workcard-upload-wrapper">
                    <el-upload action=""
                               v-if="allowAudit()"
                               :auto-upload="false"
                               :show-file-list="false"
                               accept=".jpg,.jpeg,.png,.mp4"
                               :on-change="query => onChangeFile(query)">
                      <el-button type="primary"
                                 size="small">上传工作证明
                      </el-button>
                    </el-upload>
                    <div id="photoContainer"
                         class="photo-view-container"
                         v-if="editForm.workcard_photo && editForm.workcard_photo.length > 0">
                      <div class="photo-item"
                           v-for="(photo, index) in editForm.workcard_photo"
                           :key="'workcard-' + index">
                        <!-- 零工驳回后新补证据：缩略图左上角小红点（管理端上传的不标） -->
                        <span v-if="isNewWorkcardPhoto(photo)"
                              class="photo-new-dot"
                              title="零工新补证据"></span>
                        <!-- 视频类型 -->
                        <video v-if="isVideoFile(photo)"
                               :src="photo"
                               class="photo-view-image video-preview"
                               preload="metadata"
                               @click="openVideoDialog(photo, index)">
                        </video>
                        <!-- 图片类型 -->
                        <img v-else-if="isImageFile(photo)"
                             :src="photo | ossFormatJpg"
                             @click="onViewPhotos(index)"
                             alt=""
                             class="photo-view-image">
                        <!-- 未知类型 -->
                        <div v-else
                             class="photo-view-image unknown-file"
                             :title="photo">
                          <i class="el-icon-document"></i>
                          <span>未知文件</span>
                        </div>
                        <i class="el-icon-error photo-delete-icon"
                           v-if="allowAudit()"
                           @click="onDeletePhoto(index)"></i>
                      </div>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item label="当前标签"
                              v-if="allowAudit()">
                  <div v-if="existingTags && existingTags.length"
                       class="tag-container">
                    <el-tag v-for="item in existingTags"
                            :key="item.id"
                            type="success"
                            class="tag-item">
                      {{ item.tagname }} ({{ item.id }})
                    </el-tag>
                  </div>
                  <span v-else
                        class="no-tags-text">暂无标签</span>
                </el-form-item>

                <el-form-item label="新增标签"
                              prop="tag_add"
                              v-if="allowAudit()">
                  <div class="form-input-width">
                    <remote-select v-model="editForm.tag_add"
                                   :disabled="!allowAudit()"
                                   placeholder="请输入标签名称搜索添加标签"
                                   :queryRequest="(_) => getUserTagTable(Object.assign({'is_group': 0},  ..._))"
                                   :findRequest="getUserTagDetail"
                                   clearable
                                   multiple
                                   keyword-key="keyword"
                                   value-key="id"
                                   label-key="tagname"
                                   id-key="id">
                    </remote-select>
                  </div>
                </el-form-item>
                <el-form-item label="日志"
                              prop="log">
                  <div class="log-container">
                    <div class="log-header">
                      <span class="log-time-header">时间</span>
                      <span class="log-operator-header">操作人</span>
                      <span class="log-action-header">操作内容</span>
                    </div>
                    <div v-for="(item, index) in reversedLogs"
                         :key="index"
                         class="log-item">
                      <span class="log-time">{{ item.created_at }}</span>
                      <span class="log-operator">{{ item.operator.name }} ({{ item.operator.id }})</span>
                      <span class="log-action">{{ item.action }}</span>
                    </div>
                  </div>
                </el-form-item>

                <el-form-item label="不通过原因"
                              v-if="allowAudit()"
                              prop="failed_reason">
                  <el-input placeholder="审核不通过时请填写原因（必填）"
                            v-model="auditForm.failed_reason"
                            class="form-input-width"
                            maxlength="200"
                            show-word-limit></el-input>
                </el-form-item>
                <el-form-item class="button-group">
                  <template v-if="allowAudit()">
                    <el-button type="primary"
                               icon="el-icon-check"
                               @click="auditPass()">审核通过
                    </el-button>
                    <el-button type="danger"
                               icon="el-icon-close"
                               @click="auditReject()">审核不通过
                    </el-button>
                    <el-button type="warning"
                               icon="el-icon-refresh-left"
                               @click="reloadData()">数据还原
                    </el-button>
                    <el-button icon="el-icon-back"
                               @click="goBackToTable()">返回列表页
                    </el-button>
                  </template>
                  <template v-else>
                    <el-button icon="el-icon-back"
                               @click="goBackToTable()">返回列表页
                    </el-button>
                  </template>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </layout-panel>
      </el-tab-pane>
      <el-tab-pane label="职业信息修改记录"
                   name="职业信息修改记录">
        <work-info-history v-if="detail.userid"
                           :userId="Number(detail.userid)"></work-info-history>
      </el-tab-pane>
    </el-tabs>

    <!-- 视频播放弹窗 -->
    <video-player-dialog
      :visible.sync="videoDialogVisible"
      :videos="videoDialogVideos"
      :index="videoDialogIndex" />
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import WorkInfoHistory from '@views/user-workinfo/components/work-info-history/WorkInfoHistory.vue'
import VideoPlayerDialog from '@views/user-workinfo/components/VideoPlayerDialog.vue'
import userWorkInfoMixin from '@views/user-workinfo/user-workinfo.mixin.js'

export default {
  components: {WorkInfoHistory, VideoPlayerDialog},
  mixins: [userWorkInfoMixin],
  data () {
    return {
      detail: {},
      activeName: '职业信息提交详情',
      auditForm: {
        failed_reason: null,
      },
      editForm: {
        business_type: null,
        work_type: null,
        belongto: null,
        main_brand: null,
        workcard_photo: [],
        tag_add: [],
      },
      companyList: [],
      existingTags: [],
      industryTags: [],
      videoDialogVisible: false,
      videoDialogVideos: [],
      videoDialogIndex: 0,
      // 相对首次快照，零工新补的工作证明 URL（后端对比 SJUserWorkInfoAuditSnapshot）
      newWorkcardPhotos: [],
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.users.userOptions,
    }),
    filtered_work_type () {
      return this.options.business_work_type.filter(it => {
        return it.businessTypeId + '' === this.editForm.business_type + ''
      })
    },
    reversedLogs () {
      const logs = Array.isArray(this.detail.log) ? this.detail.log : []
      return [...logs].reverse()
    },
    newWorkcardPhotoSet () {
      const list = Array.isArray(this.newWorkcardPhotos) ? this.newWorkcardPhotos : []
      const set = {}
      list.forEach(url => {
        if (url) set[url] = true
      })
      return set
    },
  },
  async created () {
    await this.$store.dispatch('getUserRelatedOptions')
    this.id = this.$route.params.id
    this.id > 0 && this.setDetailData(this.id)
  },
  methods: {
    ...Vuex.mapActions([]),
    ...request.map(['getUserTagTable', 'getUserTagDetail', 'queryWorkInfoCompany']),
    // 加载用户当前已有的标签，仅用于审核页展示
    loadExistingTags () {
      const tagStr = this.detail.tag || ''
      const ids = tagStr
        ? tagStr.split(',').map(id => Number(id)).filter(id => !isNaN(id) && id > 0)
        : []
      this.existingTags = []
      if (!ids.length) {
        return
      }
      this.getUserTagTable({ tag_id: ids }).then(({ data }) => {
        const list = (data && data.data) || []
        const normalized = list.map(tag => ({
          id: Number(tag.id),
          tagname: tag.tagname || tag.name || ('标签' + tag.id),
        }))
        this.existingTags = ids.map(id => {
          const found = normalized.find(t => t.id === id)
          return found || { id, tagname: '标签' + id }
        })
      }).catch(() => {
        // 出错时，至少按照 ID 简单展示
        this.existingTags = ids.map(id => ({ id, tagname: '标签' + id }))
      })
    },
    needMainBrand () {
      const btId = this.editForm.business_type
      if (!btId) return false
      const item = (this.options.business_type || []).find(it => Number(it.id) === Number(btId))
      return item && item.need_main_brand
    },
    onBusinessTypeChange () {
      this.editForm.work_type = null
      this.loadIndustryTags()
    },
    // 根据当前行业加载对应的标签名称
    loadIndustryTags () {
      const btId = this.editForm.business_type
      this.industryTags = []
      if (!btId) return
      const item = (this.options.business_type || []).find(it => Number(it.id) === Number(btId))
      let bindTags = item && item.bind_tags
      if (typeof bindTags === 'string') {
        try {
          bindTags = JSON.parse(bindTags)
        } catch (e) {
          bindTags = []
        }
      }
      const ids = Array.isArray(bindTags) ? bindTags.map(id => Number(id)).filter(id => id > 0) : []
      if (!ids.length) return
      this.getUserTagTable({ tag_id: ids }).then(({ data }) => {
        const list = (data && data.data) || []
        const normalized = list.map(tag => ({
          id: Number(tag.id),
          tagname: tag.tagname || tag.name || ('标签' + tag.id),
        }))
        this.industryTags = ids.map(id => normalized.find(t => t.id === id) || {id, tagname: '标签' + id})
      }).catch(() => {
        this.industryTags = ids.map(id => ({id, tagname: '标签' + id}))
      })
    },
    async setDetailData (id) {
      await request.page('getUserWorkInfoDetail', {id}).then(({data}) => {
        // 不再需要处理 tag，因为现在使用 tag_add
        this.detail = data
        // 保存公司列表
        this.companyList = data.company_list || []
        // 零工新补证据（相对首次快照）；管理端本页上传不会进此列表
        this.newWorkcardPhotos = data.new_workcard_photos || []
        // 初始化编辑表单
        this.editForm = {
          business_type: data.business_type ? Number(data.business_type) : null,
          work_type: data.work_type ? Number(data.work_type) : null,
          belongto: data.belongto || null,
          workcard_photo: data.workcard_photo || [],
          main_brand: data.main_brand || null,
          tag_add: [],
        }
        // 加载当前用户已存在的标签，仅用于展示
        this.loadExistingTags()
        // 加载行业对应标签
        this.loadIndustryTags()
      })
    },
    /**
     * 是否为零工驳回后新补的工作证明（相对首次快照）
     * 管理端上传的证据不在 new_workcard_photos 中，故不会标红点
     */
    isNewWorkcardPhoto (photo) {
      return !!(photo && this.newWorkcardPhotoSet[photo])
    },
    ifKey (scope, name) {
      return scope.row.key === name
    },
    setStatusCNColor () {
      switch (Number(this.detail.status)) {
        case 0:
          return 'orange'
        case 1:
          return 'green'
        case 2:
          return 'red'
        default:
          return 'xx'
      }
    },
    auditPass () {
      const auditForm = {
        id: this.id,
        tag_add: this.editForm.tag_add || [],
        updated_at: this.detail.updated_at,
        is_rejected: 0,
        business_type: this.editForm.business_type,
        work_type: this.editForm.work_type,
        belongto: this.editForm.belongto,
        main_brand: this.editForm.main_brand,
        workcard_photo: this.editForm.workcard_photo,
      }
      // 当前行业需要主营品牌时，前端做必填校验
      if (this.needMainBrand() && !this.editForm.main_brand) {
        this.$message.warning('当前行业需要填写主营品牌')
        return
      }
      this.$confirm('确认审核通过？', '提示', {type: 'success'}).then(() => {
        request.common('auditUserWorkInfoData', auditForm).then(() => {
          this.auditNext('已通过，是否审核下一条用户职业信息？')
        })
      })
    },
    auditReject () {
      // 前端验证：不通过原因必填
      if (!this.auditForm.failed_reason || this.auditForm.failed_reason.trim() === '') {
        this.$message.warning('请填写不通过原因')
        return
      }

      const auditForm = {
        id: this.id,
        tag_add: this.editForm.tag_add || [],
        is_rejected: 1,
        updated_at: this.detail.updated_at,
        failed_reason: this.auditForm.failed_reason,
        business_type: this.editForm.business_type,
        work_type: this.editForm.work_type,
        belongto: this.editForm.belongto,
        main_brand: this.editForm.main_brand,
        workcard_photo: this.editForm.workcard_photo,
      }
      this.$confirm('确认审核不通过？', '提示', {type: 'success'}).then(() => {
        request.common('auditUserWorkInfoData', auditForm).then((res) => {
          this.auditNext('审核不通过处理成功，是否审核下一条用户职业信息？')
        })
      }, () => {})
    },
    auditNext (msg) {
      this.$confirm(msg, '提示', {
        type: 'success', confirmButtonText: '审核下一条', cancelButtonText: '返回列表', showClose: false
      }).then(() => {
        request.common('getNextAuditWorkInfoId', {}).then((res) => {
          if (res.data > 0) {
            self.location.href = `/user-workinfo/audit/${res.data}`
          } else {
            this.$alert('无更多待审核数据', '提示', {type: 'warning', confirmButtonText: '返回列表'}).then(() => {
              this.goBackToTable()
            })
          }
        })
      }, () => {
        this.goBackToTable()
      })
    },
    goBackToTable () {
      this.$router.push({path: '/user-workinfo/table'})
    },
    allowAudit () {
      return this.detail.status + '' === '0' && this.$route.meta.type === 'audit'
    },
    onViewPhotos (index) {
      if (this.viewer) {
        this.viewer.destroy()
      }
      this.viewer = new Viewer(document.getElementById('photoContainer'))
      this.viewer.view(index)
    },
    getBusinessType () {
      return _.get(this.detail, 'business_type_json.title', '-')
    },
    getMainBrand () {
      const value = _.get(this.detail, 'main_brand')
      if (value && value.toString().trim() !== '') {
        return value
      }
      // 如果当前行业配置为需要主营品牌，即使为空也要展示占位符，方便运营发现未填写
      if (this.needMainBrand()) {
        return '—'
      }
      return null
    },
    getUserLocation () {
      const province = _.get(this.detail, 'province_name', '')
      const city = _.get(this.detail, 'city_name', '')
      const area = _.get(this.detail, 'area_name', '')
      let location = ''
      if (province) location += ' ' + province
      if (city) location += ' ' + city
      if (area) location += ' ' + area
      return location
    },
    async onChangeFile (file) {
      const url = await this.onChangeUserWorkInfoEvidence(file)
      if (url) {
        this.editForm.workcard_photo.push(url)
      }
    },
    onDeletePhoto (index) {
      this.editForm.workcard_photo.splice(index, 1)
    },
    async queryCompanyList (queryString, cb) {
      // 如果查询字符串为空，返回空数组
      if (!queryString || queryString.trim() === '') {
        const emptyList = []
        cb(emptyList)
        return
      }

      try {
        // 调用后端API进行远程搜索
        const {data} = await request.common('queryWorkInfoCompany', {
          name: queryString.trim(),
          per_page: 20, // 限制返回数量
          current_page: 1,
        })

        const companies = (data && data.data) || []
        // 格式化数据为 el-autocomplete 需要的格式
        const formattedResults = companies.map(company => ({
          value: company.name,
          id: company.id,
        }))
        cb(formattedResults)
      } catch (error) {
        console.error('搜索公司失败:', error)
        // 出错时返回空数组
        const emptyList = []
        cb(emptyList)
      }
    },
    handleCompanySelect (item) {
      this.editForm.belongto = item.value
    },
    async reloadData () {
      try {
        await this.$confirm('确认还原数据？还原后将重新加载当前数据。', '提示', {type: 'warning'})
        await this.setDetailData(this.id)
        this.$message({
          showClose: true,
          message: '数据还原成功',
          type: 'success',
        })
      } catch (error) {
        // 用户取消操作时不显示错误消息
        if (error !== 'cancel') {
          this.$message({
            showClose: true,
            message: '数据还原失败',
            type: 'error',
          })
        }
      }
    },
    /**
     * 打开视频播放弹窗（委托给独立组件 VideoPlayerDialog）
     * @param {string} url - 视频URL
     * @param {number} index - 在 workcard_photo 中的索引（保留以兼容调用处）
     */
    openVideoDialog (url, index) {
      // 构造所有视频URL列表，并计算当前索引
      const videoList = (this.editForm.workcard_photo || []).filter(photo => this.isVideoFile(photo))
      this.videoDialogVideos = videoList
      this.videoDialogIndex = Math.max(videoList.indexOf(url), 0)
      this.videoDialogVisible = true
    },

  },
}
</script>
<style lang="scss"
       scoped>
// 确保表单容器有足够宽度
.re-el-form__flex {
  .large {
    width: 100%;
    max-width: none;
  }
}

// 统一输入框宽度
.form-input-width {
  width: 400px;
  max-width: 100%;
}

// remote-select 组件需要深度选择器来设置内部元素宽度 - 使用全局样式
.form-input-width .el-select,
.form-input-width .el-input,
.form-input-width .el-input__inner,
.form-input-width .el-select__tags,
.form-input-width .el-select__tags-text {
  width: 100% !important;
  max-width: 100%;
}

// 确保 remote-select 本身也是 100% 宽度
.form-input-width > * {
  width: 100% !important;
}

.el-form-item {
  margin-bottom: 22px;

  &:last-child {
    margin-bottom: 0;
  }
}

// 用户信息样式
.user-info-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  .info-divider {
    color: #dcdfe6;
    font-size: 14px;
    flex-shrink: 0;
  }

  .info-text {
    color: #606266;
    font-size: 14px;
    white-space: nowrap;
  }
}

// 工作证明上传样式
.workcard-upload-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.photo-view-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 12px;
}

.photo-item {
  position: relative;
  display: inline-block;
}

// 零工新补证据：缩略图左上角小红点
.photo-new-dot {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 8px;
  height: 8px;
  background-color: #f56c6c;
  border-radius: 50%;
  border: 1px solid #fff;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.25);
  z-index: 2;
  pointer-events: none;
}

.workcard-image {
  width: 100px;
  height: 100px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.3s;

  &:hover {
    border-color: #409eff;
  }
}

.photo-delete-icon {
  position: absolute;
  top: -8px;
  right: -8px;
  font-size: 20px;
  cursor: pointer;
  color: #f56c6c;
  background: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.1);
  }
}

.photo-view-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.photo-view-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: zoom-in;
  transition: border-color 0.3s, transform 0.2s;

  &:hover {
    border-color: #409eff;
    transform: scale(1.05);
  }

  // 未知文件样式
  &.unknown-file {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #f5f7fa;
    cursor: default;
    font-size: 12px;
    color: #909399;
    text-align: center;
    padding: 4px;
    box-sizing: border-box;

    i {
      font-size: 24px;
      margin-bottom: 2px;
      color: #dcdfe6;
    }

    span {
      line-height: 1.2;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }
  }
}

// 视频元素特殊样式 - 确保控制条可点击
.photo-item video.photo-view-image {
  cursor: pointer;
  background-color: #1a1a1a;

  // 确保控制条可见且可点击
  &::-webkit-media-controls {
    display: flex !important;
    opacity: 1 !important;
  }

  // 确保视频可以点击播放
  pointer-events: auto !important;
}

// 日志样式
.log-container {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  background-color: #f5f7fa;
  border-radius: 4px;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  max-width: 800px;
}

.log-header {
  display: grid;
  grid-template-columns: 150px 150px 400px;
  gap: 12px;
  padding: 12px 16px;
  background-color: #fafafa;
  border-bottom: 1px solid #ebeef5;
  font-weight: 600;
  font-size: 14px;
  color: #303133;
  position: sticky;
  top: 0;
  z-index: 1;

  .log-time-header,
  .log-operator-header,
  .log-action-header {
    color: #303133;
  }
}

.log-item {
  display: grid;
  grid-template-columns: 150px 150px 400px;
  gap: 12px;
  padding: 10px 16px;
  line-height: 1.6;
  font-size: 14px;
  border-bottom: 1px solid #ebeef5;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f0f2f5;
  }

  .log-time {
    color: #909399;
    white-space: nowrap;
  }

  .log-operator {
    color: #606266;
    font-weight: 500;
    white-space: nowrap;
  }

  .log-action {
    color: #303133;
    word-break: break-word;
    max-width: 400px;
  }
}

// 按钮组样式
.button-group {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;

  .el-button {
    margin-right: 12px;

    &:last-child {
      margin-right: 0;
    }
  }
}

// 统一只读文本样式
.readonly-field {
  span {
    color: #606266;
    font-size: 14px;
  }
}

.helper-text {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}

.tag-inline {
  margin-right: 8px;
}

// 标签展示样式
.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-item {
  margin: 0;
  border-radius: 16px;
}

.no-tags-text {
  color: #909399;
  font-size: 14px;
}

// 视频预览样式 - 提示可以点击
.video-preview {
  position: relative;
  cursor: pointer !important;
  background-color: #000;
}

</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/user-workinfo/pages/UserWorkInfoDetail.vue